export default "__VITE_ASSET__l1es$ew4__"